import './index.scss'
import React, { useState, useEffect, useRef } from 'react'
import { Modal, Popover, Radio, Select, message } from 'antd'
import sensors, { sensorsRole } from '../../../../utils/sensors'
import naming_icon from '../../../../images/example.png'
import floder_icon from '../../../../images/folder_icon.png'
import contact_us_icon from '../../../../images/contact_us.png'
import { useAppSelector } from '../../../../app/hooks'

import {
  sliceCharactersLen,
  raplaceEmoji,
  filterIllegalCharacters,
  calcCharactersLength
} from '../../../../utils/utils'
import VipAlert from './VipAlert'
import Footer from './Footer'
import { calcCheckedPhotoNum } from '../../Detail/lib/photo'

import ContactUS from '../../../components/ContactUS'
import { CaretDownOutlined } from '@ant-design/icons'

const RadioGroup = Radio.Group
const Option = Select.Option

const namingExample: Record<string, string> = {
  user: '王某',
  time: '2020-09-03 20_41_18',
  address: '北京市三里屯',
  watermark: '打卡水印',
  photoNumber: '180-090-1234'
}

const presetRuleArray = ['user', 'time', 'address', 'watermark', 'photoNumber']

const sensorsFolderType = (folderRule: string) => {
  return folderRule === 'user'
    ? 'byPeople'
    : folderRule === 'date'
      ? 'byDate'
      : 'noFolder'
}

const sensorsNameRule = (namingRule: string[]) => {
  return namingRule.map((rule) => {
    switch (rule) {
      case 'user':
        return '拍摄人姓名'
      case 'time':
        return '拍摄时间'
      case 'address':
        return '拍摄地点'
      case 'watermark':
        return '水印模板'
      case 'photoNumber':
        return '照片编号'
      default:
        return ''
    }
  })
}

interface TitleItem {
  titleId: string
  titleName: string
  [key: string]: any
}

interface FolderModalProps {
  visible: boolean
  photoTitleList: TitleItem[]
  folderTitleList: TitleItem[]
  onClose: () => void
  onOk: (namingRule: string[]) => void
}

function FolderModal({
  visible,
  photoTitleList,
  folderTitleList,
  onClose,
  onOk
}: FolderModalProps) {
  const [namingRule, setNamingRule] = useState<string[]>([
    'user',
    'time',
    'watermark'
  ])
  const [folderTitles, setFolderTitles] = useState('watermark')
  const [folderRule, setFolderRule] = useState('')

  // 从 Redux 获取状态
  const myRole = useAppSelector((state) => state.group.myRole)
  const isVip = useAppSelector((state) => state.group.isVip)
  const groupId = useAppSelector((state) => state.group.groupId)
  // folder state 现在是普通对象
  const folderState = useAppSelector((state) => state.folder)

  // 保存上一次的 visible 值
  const prevVisibleRef = useRef<boolean>()

  useEffect(() => {
    if (prevVisibleRef.current !== visible && visible === true) {
      const storedNamingRule = JSON.parse(
        localStorage.getItem('namingRule') || 'null'
      )
      if (storedNamingRule) {
        const namingList = storedNamingRule.filter((item) => {
          if (!item.includes('title')) {
            return true
          } else {
            const id = item.split('title')[1]
            for (const item of photoTitleList) {
              if (item.titleId === id) {
                return true
              }
            }
          }
          return false
        })
        setNamingRule(namingList)
      }
      // 文件夹命名规则回显
      const storedFolderRule = localStorage.getItem('folderRule')
      const storedFolderTitles = localStorage.getItem('folderTitles')

      if (storedFolderRule) {
        setFolderRule(storedFolderRule)
      }

      if (
        folderTitleList.length !== 0 &&
        storedFolderTitles &&
        storedFolderTitles !== 'watermark'
      ) {
        const index = folderTitleList.findIndex((item) => {
          if (item.titleId === storedFolderTitles) {
            return true
          }
        })
        if (index >= 0) {
          setFolderTitles(storedFolderTitles)
        }
      }
    }
    prevVisibleRef.current = visible
  }, [visible, photoTitleList, folderTitleList])

  const onChangeSelectNameData = (value, list) => {
    if (value.length > 5) {
      value = value.slice(0, 5)
      list = list.slice(0, 5)
      message.warning('最多支持选择5个命名条件!')
    }

    value = value.reduce((prev, cur) => {
      const initLength = cur.length
      cur = raplaceEmoji(cur)
      cur = filterIllegalCharacters(cur)
      if (initLength !== cur.length) {
        message.warning('特殊字符已过滤！')
      }

      if (cur.trim() !== '') {
        if (!cur.includes('title') && calcCharactersLength(cur) > 32) {
          cur = sliceCharactersLen(cur, 32)
          message.warning('最多支持16个汉字或32个字符！')
        }
        if (!prev.includes(cur)) {
          prev.push(cur)
        }
      } else {
        list.splice(prev.length, 1)
      }
      return prev
    }, [])
    setNamingRule(value)
  }

  const handleOk = () => {
    localStorage.setItem('namingRule', JSON.stringify(namingRule))
    sensors.track('web_workgroup_export_setpage_click', {
      nameRule: sensorsNameRule(namingRule)
    })
    sensors.track('web_click_page_workgroup_pic_download', {
      clickItem: 'download',
      role: sensorsRole(myRole),
      groupID: groupId,
      isVip,
      photoNum: calcCheckedPhotoNum(folderState),
      fromPlace: '分类文件夹',
      track_sign:
        'aworkgroup.b4347.action.web_click_page_workgroup_pic_download',
      requirement_id: 221
    })
    // 服务端接收的数据格式：1、自定义：diy:+name, 2、 头目：title:+name, 3、其他

    const parsedNamingRule = namingRule.map((item) => {
      if (item.includes('title')) {
        return 'title:' + item.split('title')[1]
      } else if (!presetRuleArray.includes(item)) {
        return 'diy:' + item
      } else {
        return item
      }
    })

    // 只传递命名规则，移除折叠规则相关参数
    onOk(parsedNamingRule)
  }

  const handleFolderClick = (e) => {
    const { value } = e.target
    setFolderRule(value)
    setFolderTitles('watermark')
  }

  const exampleName =
    namingRule
      .map((rule) => {
        if (namingExample[rule]) {
          return namingExample[rule]
        } else if (!rule.includes('title')) {
          return rule
        } else {
          for (const items of photoTitleList) {
            const value = rule.split('title')[1]
            if (value === items.titleId) {
              return items.titleName
            }
          }
        }
        return ''
      })
      .join(' ') + '.jpg'

  return (
    <Modal
      open={visible}
      className="folder-modal folder-style"
      getContainer={false}
      width={602}
      centered
      title="图片/视频下载"
      mask={{ closable: false }}
      closeIcon={
        <ContactUS
          fromPage="照片下载"
          track={() => {
            sensors.track('web_click_page_workgroup_pic_download', {
              clickItem: 'contactUs',
              role: sensorsRole(myRole),
              groupID: groupId,
              isVip,
              photoNum: calcCheckedPhotoNum(folderState),
              fromPlace: '分类文件夹',
              track_sign:
                'aworkgroup.b4347.action.web_click_page_workgroup_pic_download',
              requirement_id: 221
            })
          }}
        >
          <span className="contact-item">
            <img style={{ width: '105px' }} src={contact_us_icon} />
          </span>
        </ContactUS>
      }
      footer={
        <Footer namingRule={namingRule} onCancel={onClose} onOk={handleOk} />
      }
    >
      <VipAlert visible={visible} />
      {/* <div className="rule-block">
        <div className="rule-title">
          <div>
            <span className="title">照片归类方式</span>{' '}
            <span className="subtitle">对照片进行归类，整理成文件夹</span>
          </div>
        </div>
        <RadioGroup
          value={folderRule}
          className="radio-group-file"
          style={{ marginLeft: '18px' }}
          onChange={handleFolderClick}
        >
          <Radio value="user" className="RadioItem">
            <div>
              <div className="img">
                <img src={floder_icon} />
              </div>
              <div className="text">按拍摄人</div>
            </div>
          </Radio>
          <Radio value="date">
            <div>
              <div className="img">
                <img src={floder_icon} />
              </div>
              <div className="text">按拍摄日期</div>
            </div>
          </Radio>
          <Radio value="customize">
            <div>
              <div className="img">
                <img src={floder_icon} />
              </div>
              <div className="text">自定义</div>
            </div>
          </Radio>
          <Radio value="">
            <div>
              <div className="img">
                <img src={floder_icon} />
              </div>
              <div className="text">不归类</div>
            </div>
          </Radio>
        </RadioGroup>
        {folderRule === 'customize' && (
          <div className="rule-split">
            <div className="rule-split-content">照片拆分规则</div>
            <Select
              suffixIcon={<Icon type="caret-down" />}
              style={{ width: '380px', color: '#323233' }}
              value={folderTitles}
              onChange={(value) => {
                setFolderTitles(value)
              }}
            >
              <Option key="-1" value="watermark">
                水印名称
              </Option>
              {folderTitleList.map((item, index) => (
                <Option key={index} value={item.titleId}>
                  {item.titleName}
                </Option>
              ))}
            </Select>
          </div>
        )}
      </div> */}
      <div className="rule-block">
        <div className="rule-title">
          <div>
            <span className="title">照片/视频命名方式</span>{' '}
            <span className="subtitle">对下载的照片进行重命名</span>
          </div>
        </div>
        {namingRule.length ? (
          <div>
            <div className="example">
              <img src={naming_icon} alt="" />
              <p>{exampleName}</p>
            </div>
          </div>
        ) : (
          <p style={{ color: '#f5222d', marginLeft: '16px' }}>请至少选择一项</p>
        )}
        <Select
          mode="tags"
          style={{
            width: 'calc(100% - 32px)',
            margin: '0px 16px',
            color: '#000'
          }}
          className="select-mutil-tag"
          suffixIcon={<CaretDownOutlined />}
          showArrow
          placeholder="请选择或输入内容进行命名"
          value={namingRule}
          dropdownClassName="dropdown-tag"
          onChange={onChangeSelectNameData}
        >
          <Option key="user">拍摄人姓名</Option>
          <Option key="time">拍摄日期</Option>
          <Option key="address">拍摄地点</Option>
          <Option key="watermark">水印名称</Option>
          <Option key="photoNumber">照片编号</Option>
          {photoTitleList.map((item) => (
            <Option key={'title' + item.titleId}>{item.titleName}</Option>
          ))}
        </Select>
      </div>
    </Modal>
  )
}

export default FolderModal
